module.exports = __webpack_public_path__ + "img/yx-t.5b5293b8.png";